var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinnerBlackSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "12.25px",
    height: "12.25px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 26,
    rx: 1.6,
    ry: 1.6,
    width: 4,
    height: 16,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.875s",
    repeatCount: "indefinite"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 26,
    rx: 1.6,
    ry: 1.6,
    width: 4,
    height: 16,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.75s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 26,
    rx: 1.6,
    ry: 1.6,
    width: 4,
    height: 16,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.625s",
    repeatCount: "indefinite"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(135 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 26,
    rx: 1.6,
    ry: 1.6,
    width: 4,
    height: 16,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.5s",
    repeatCount: "indefinite"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 26,
    rx: 1.6,
    ry: 1.6,
    width: 4,
    height: 16,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.375s",
    repeatCount: "indefinite"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(225 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 26,
    rx: 1.6,
    ry: 1.6,
    width: 4,
    height: 16,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.25s",
    repeatCount: "indefinite"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(270 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 26,
    rx: 1.6,
    ry: 1.6,
    width: 4,
    height: 16,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.125s",
    repeatCount: "indefinite"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(315 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 26,
    rx: 1.6,
    ry: 1.6,
    width: 4,
    height: 16,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "0s",
    repeatCount: "indefinite"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerBlackSm);
export default __webpack_public_path__ + "static/media/spinner-black-sm.d32c0487a62d637cd9e5ecbc85eab110.svg";
export { ForwardRef as ReactComponent };